const CollectionsService = {
  getCollections: async (payload = {}) => {
    const params = Object.keys(payload).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`).join('&');
    const { data, headers } = await ovpFetch(`/collections?${params}`);
    const pagination = {
      max_page: 1,
      current_page: payload.page,
    };

    const { link } = headers;
    if (link) {
      const linkSplit = link.split(',');
      const lastIndex = linkSplit.findIndex(rel => rel.includes('rel="last"'));
      const prevIndex = linkSplit.findIndex(rel => rel.includes('rel="prev"'));
      if (lastIndex > -1) {
        pagination.max_page = parseInt(linkSplit[lastIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10);
      } else if (prevIndex > -1) {
        pagination.max_page = parseInt(linkSplit[prevIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10) + 1;
      }
      pagination.current_page = pagination.max_page < pagination.current_page ? pagination.max_page : pagination.current_page;
    }

    return {
      collections: data,
      pagination,
    };
  },

  getCollectionItems: async (payload = {}) => {
    const params = Object.keys(payload).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`).join('&');
    const { data, headers } = await ovpFetch(`/medialibrary?${params}`);
    const pagination = {
      max_page: 1,
      current_page: payload.page,
    };

    const { link } = headers;
    if (link) {
      const linkSplit = link.split(',');
      const lastIndex = linkSplit.findIndex(rel => rel.includes('rel="last"'));
      const prevIndex = linkSplit.findIndex(rel => rel.includes('rel="prev"'));
      if (lastIndex > -1) {
        pagination.max_page = parseInt(linkSplit[lastIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10);
      } else if (prevIndex > -1) {
        pagination.max_page = parseInt(linkSplit[prevIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10) + 1;
      }
      pagination.current_page = pagination.max_page < pagination.current_page ? pagination.max_page : pagination.current_page;
    }

    return {
      items: data,
      pagination,
    };
  },

  getCollection: async (id) => {
    const { data } = await ovpFetch(`/collections/${id}`);
    return data;
  },

  deleteCollection: async (id) => {
    await ovpFetch(`/collections/${id}`, {
      method: 'DELETE',
      iLikeItRaw: true,
    });
    return true;
  },

  createCollection: async (payload) => {
    const { data } = await ovpFetch('/collections', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return data.id;
  },

  updateCollection: async (id, payload) => {
    const { data } = await ovpFetch(`/collections/${id}`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return data;
  },

  addBroadcastToCollection: async (broadcastId, collectionId) => {
    await ovpFetch(`/collections/${collectionId}/add`, {
      method: 'POST',
      body: broadcastId,
    });
    return true;
  },

  removeBroadcastFromCollection: async (broadcastId, collectionId) => {
    await ovpFetch(`/collections/${collectionId}/remove`, {
      method: 'POST',
      body: broadcastId,
    });
  },

  uploadPoster: async (id, file) => {
    const { data } = await ovpFetch(`/collections/${id}/poster`, {
      method: 'POST',
      body: file,
      defaultContentType: true,
    });
    return data;
  },
};

// eslint-disable-next-line
export { CollectionsService };
